<div *ngIf="fileTableData">
  <div *ngIf="fileTableData.length === 1; else showCategories">
    <jml-lib-dynamic-table
      class="p-0"
      [tableData]="fileTableData[0]"
      [mainId]="ownerId"
      [mainType]="ownerType"
      [isRootEntity]="false"
    ></jml-lib-dynamic-table>
  </div>

  <ng-template #showCategories>
    <p-tabView [style]="{ 'margin-bottom': '15px' }">
      <ng-template ngFor let-category [ngForOf]="categories" let-i="index">
        <p-tabPanel [header]="category.displayName">
          <jml-lib-dynamic-table
            class="p-0"
            [tableData]="fileTableData[i]"
            [mainId]="ownerId"
            [mainType]="ownerType"
            [attachmentCategory]="category.attachmentCatHrid"
            [isRootEntity]="false"
          ></jml-lib-dynamic-table>
        </p-tabPanel>
      </ng-template>
      <p-tabPanel *ngIf="showZombieAttachmentTab" header="Andere">
        <jml-lib-dynamic-table
          class="p-0"
          *ngIf="fileTableData"
          [tableData]="fileTableData[fileTableData.length - 1]"
          [mainId]="ownerId"
          [mainType]="ownerType"
          [attachmentCategory]="'Andere'"
          [isRootEntity]="false"
        ></jml-lib-dynamic-table>
      </p-tabPanel>
    </p-tabView>
  </ng-template>
</div>
